import React from 'react';
import { DateTime } from 'luxon';
import HiddenTag from '../../../../components_cards/tags/_resource/HiddenTag';
import MissingFieldsTag from '../../../../components_cards/tags/MissingFieldsTag';
import CancelledTag from '../../../../components_cards/tags/_resource/CancelledTag';
import CompletedTag from '../../../../components_cards/tags/_resource/CompletedTag';
import ExpiredTag from '../../../../components_cards/tags/_resource/ExpiredTag';
import useMissingFields from '../../../project-manage/useMissingFields';

export default function StatusTags(props) {
  const { project } = props;

  const { missingFields } = useMissingFields(project);

  if (project.data.cancelled) {
    return (
      <div className="flex space-x-4">
        <CancelledTag resource={project} />
        {!project.data.published && (
          <HiddenTag resource={project} />
        )}
      </div>
    );
  }

  if (project.data.completed) {
    return (
      <div className="flex space-x-4">
        <CompletedTag resource={project} />
        {!project.data.published && (
          <HiddenTag resource={project} />
        )}
      </div>
    );
  }

  const diff = DateTime.now().diff(DateTime.fromISO(project.data.endDate)).as('days');

  if (
    diff >= 0 ||
    !project.data.published ||
    missingFields.data.length > 0
  ) {
    return (
      <div className="flex space-x-4">
        {diff >= 0 && (
          <ExpiredTag resource={project} />
        )}
        {!project.data.published && (
          <HiddenTag resource={project} />
        )}
        {missingFields.data.length > 0 && (
          <MissingFieldsTag resource={project} />
        )}
      </div>
    );
  }

  return null;
}
